import { injectable } from 'tsyringe';
import { UipTranslationService } from '@/Feature/Uip/platform/app/services';
import { createElement } from '@gn-audio/core/common/templating';
import { isSiteFeatureEnabled } from '@gn-audio/core/common/utilities';
import { IUipMenuItem } from '@/Feature/Uip/platform/app/models';
import { SiteFeature } from '@gn-audio/core/api/site-settings/enums';
import { IMyJabraSetting } from '@gn-audio/core/api/site-settings/models/my-jabra-setting';
import { fetchMyJabraSetting } from '@gn-audio/core/api/site-settings/fetch-my-jabra-setting';

import './uip-menu-item-my-jabra.component.scss';

import template from './uip-menu-item-my-jabra.component.html';

@injectable()
export class UipMenuItemMyJabraComponent implements IUipMenuItem {
  private element?: Element;

  constructor(private readonly translationService: UipTranslationService) { }

  public destroy() {
    this.element?.remove();
  }

  public async render(container: Element) {
    const setting: IMyJabraSetting | null = await fetchMyJabraSetting();
    this.element = createElement(template, setting || {}, await this.translationService.translations);
    container.appendChild(this.element);
  }

  public async shouldRender() {
    return await isSiteFeatureEnabled(SiteFeature.TopMenuMyJabraEnabled);
  }
}
